import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
  loading?: boolean;
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ children, className = '', variant = 'primary', size = 'default', loading, fullWidth, ...props }) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-xl font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-background active:scale-[0.98] transform duration-150 touch-manipulation shadow-sm backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed select-none cursor-pointer';
  
  const variantClasses = {
    primary: 'bg-primary hover:bg-primary-dark border border-primary/50 text-white focus:ring-primary shadow-glow shadow-primary/25',
    secondary: 'bg-surface-light hover:bg-surface border border-border-strong/30 text-text-main hover:text-white focus:ring-primary/30',
    danger: 'bg-rose-600 hover:bg-rose-700 border border-rose-500/50 text-white focus:ring-rose-600 shadow-rose-600/25',
    ghost: 'bg-transparent hover:bg-surface-light/60 border border-transparent text-text-secondary hover:text-text-main focus:ring-primary/20 shadow-none hover:shadow-none',
  };

  const sizeClasses = {
    default: 'px-4 py-2 text-sm',
    sm: 'px-3 py-1.5 text-xs',
    lg: 'px-6 py-3 text-base font-semibold',
  };

  const widthClass = fullWidth ? 'w-full' : '';

  return (
    <button className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${widthClass} ${className}`} disabled={loading || props.disabled} {...props}>
      {loading && (
        <svg className="animate-spin -ml-1 mr-2.5 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      {children}
    </button>
  );
};
